export enum TipoUsuarioEnum {
  Administrador = 1,
  AdministradorDescription = 'Administração',
  AutoridadeCertificadora = 2,
  AutoridadeCertificadoraDescription = 'Autoridade Certificadora',
  AutoridadeRegistro = 3,
  AutoridadeRegistroDescription = 'Autoridade de Registro',
  LocalAtendimento = 4,
  LocalAtendimentoDescription = 'Local de Atendimento'
}
